const Checkout = {
  makePayment: 'Checkout',
  getLinkPayment: 'Checkout/GetBuyerPassenger',
};

export default Checkout;
